"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const styling_1 = require("../../styling");
const styles_1 = tslib_1.__importDefault(require("./styles"));
function Tooltip({ classes = {}, children, active }) {
    const mergedClasses = (0, styling_1.useStyles)({ source: classes, target: styles_1.default }, "tooltip");
    return react_1.default.createElement("div", { className: `${mergedClasses.root} ${active ? "active" : "inactive"}` }, children);
}
exports.default = Tooltip;
//# sourceMappingURL=Tooltip.js.map